import { render, staticRenderFns } from "./service_name_change.vue?vue&type=template&id=9517a2ac&scoped=true&lang=pug&"
import script from "./service_name_change.vue?vue&type=script&lang=js&"
export * from "./service_name_change.vue?vue&type=script&lang=js&"
import style0 from "./service_name_change.vue?vue&type=style&index=0&id=9517a2ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9517a2ac",
  null
  
)

export default component.exports